export default "__VITE_ASSET__ceb11613__"